import PermissionGuard from 'components/Global/PermissionGuard'; 
import ReportByLeaveTypeComponent from 'components/Report/ReportByLeaveType';

const LeaveTypeReport = () => {
	return (
		<PermissionGuard permission="Allow_Payroll_Reports">
			<ReportByLeaveTypeComponent />
		</PermissionGuard>
	);
};

export default LeaveTypeReport;
